import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';

interface DateRangeFilterProps {
    onApply: (start: string | null, end: string | null) => void;
    initialStart?: string;
    initialEnd?: string;
}

export default function DateRangeFilter({ onApply, initialStart, initialEnd }: DateRangeFilterProps) {
    const [start, setStart] = useState(initialStart || '');
    const [end, setEnd] = useState(initialEnd || '');

    const handleApply = () => {
        onApply(start || null, end || null);
    };

    const handleClear = () => {
        setStart('');
        setEnd('');
        onApply(null, null);
    };

    return (
        <Card className="mb-6">
            <CardContent className="pt-6">
                <div className="flex flex-wrap gap-4 items-end">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-gray-700">Start Date</label>
                        <input
                            type="date"
                            value={start}
                            onChange={(e) => setStart(e.target.value)}
                            className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-gray-700">End Date</label>
                        <input
                            type="date"
                            value={end}
                            onChange={(e) => setEnd(e.target.value)}
                            className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={handleApply}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
                        >
                            Apply Filter
                        </button>
                        <button
                            onClick={handleClear}
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-200 transition-colors"
                        >
                            Clear
                        </button>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
